import React, { useState, useEffect, useContext } from 'react';
import { AppContext } from './AppContext';
import { doc, getDoc, getFirestore } from 'firebase/firestore';
import { RealTimeAgo } from './RealTimeAgo';
import ArtistIcon1 from './assets/ArtistIcon1.png';
import ArtistIcon2 from './assets/ArtistIcon2.png';

const DEFAULT_PROFILE_URL =
  'https://firebasestorage.googleapis.com/v0/b/spndat-7d730.appspot.com/o/profile_pictures%2FjKG6lpkSmZTKXMXxS4Mm0kRdgKK2?alt=media&token=d10994a2-f842-47bf-84f5-766f44eb7afe';

const ProfilesDisplaySharePost = ({ onPress, userProfile }) => {
  const {
    newProfileImageCache,
    setNewProfileImageCache
  } = useContext(AppContext);
  const db = getFirestore();

  // 1) Initialize from cache or incoming URL
  const [profileImageUrl, setProfileImageUrl] = useState(
    newProfileImageCache[userProfile.userId] ||
    userProfile.profileImageUrl ||
    DEFAULT_PROFILE_URL
  );
  const [isLoadingProfilePicture, setIsLoadingProfilePicture] = useState(false);

  // 2) If cache updates elsewhere, sync in
  useEffect(() => {
    const cached = newProfileImageCache[userProfile.userId];
    if (cached && cached !== profileImageUrl) {
      setProfileImageUrl(cached);
    }
  }, [newProfileImageCache, userProfile.userId]);

  // 3) Only fetch if we're still pointing at the default placeholder
  useEffect(() => {
    const shouldFetch =
      profileImageUrl === DEFAULT_PROFILE_URL;

    if (!shouldFetch) return;

    setIsLoadingProfilePicture(true);
    getDoc(doc(db, 'users', userProfile.userId))
      .then(snap => {
        if (snap.exists()) {
          const url = snap.data().profileImageUrl || DEFAULT_PROFILE_URL;
          setProfileImageUrl(url);
          // store in cache for future
          setNewProfileImageCache(prev => ({
            ...prev,
            [userProfile.userId]: url,
          }));
        }
      })
      .catch(err => console.error('Error fetching profile image:', err))
      .finally(() => setIsLoadingProfilePicture(false));
  }, [userProfile.userId, profileImageUrl, db, setNewProfileImageCache]);

  const isArtistIcon2Visible = [
    'Cole','@Cole','@Sonny','@Anuva','@CharlieP','Sonny','Anuva','CharlieP'
  ].includes(userProfile.username);

  const formatUsername = u => {
    if (!u) return '@';
    return u.startsWith('@') ? u : '@' + u;
  };

    const hasPreview = userProfile?.songSnippet?.previewURL ? true : false;

  return (
    <div onClick={onPress} style={styles.container}>
      <div style={styles.profileViewStyle}>
        <div style={styles.imageStack}>
          {isLoadingProfilePicture ? (
            <div style={styles.loaderContainer}>
              Loading...
            </div>
          ) : (
            <img
              src={profileImageUrl}
              alt="Profile"
              style={styles.circularImage}
            />
          )}
        </div>

        <div style={styles.textContainer}>
          <div style={styles.nameAndTimestampContainer}>

          </div>

<div
  style={{
    ...styles.textWithIconContainer,
    ...(hasPreview ? { marginTop: -20 } : {})
  }}
>

            <span style={styles.username}>
              {formatUsername(userProfile.username)}
            </span>
            {userProfile.accountType !== 'Fan' && !isArtistIcon2Visible && (
              <img
                src={ArtistIcon1}
                alt="Artist Icon"
                style={styles.profilePicIcon}
              />
            )}
            {userProfile.accountType !== 'Fan' && isArtistIcon2Visible && (
              <img
                src={ArtistIcon2}
                alt="Artist Icon"
                style={styles.profilePicIcon}
              />
            )}
                        <RealTimeAgo
              timestamp={userProfile.createdAt}
              style={styles.timeAgoStyle}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 20,
    cursor: 'pointer',
  },
  profileViewStyle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  imageStack: {
    width: 40,
    height: 40,
    borderRadius: '50%',
    overflow: 'hidden',
    position: 'relative',
  },
  loaderContainer: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: '#222',
    color: '#fff',
    fontSize: 12,
  },
  circularImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: 10,
  },
  nameAndTimestampContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  artistName: {
    color: '#fff',
    fontSize: 16,
    fontWeight: 'bold',
    fontFamily: 'brhendrix',
  },
  timeAgoStyle: {
    color: '#fff',
    fontSize: 14,
    marginLeft: 6,
    alignSelf: 'flex-start',
  },
  textWithIconContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 2,
  },
  username: {
    color: '#62fbfa',
    fontSize: 14,
    fontFamily: 'brhendrix',
    marginRight: 4,
  },
  profilePicIcon: {
    width: 16,
    height: 16,
    objectFit: 'contain',
  },
};

export default ProfilesDisplaySharePost;
